import Page, { getStaticProps as compGetStaticProps } from 'components/pages/ContactForm';

export const getStaticProps = compGetStaticProps;
export default Page;
